<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div v-if="items != null">
    <EditDialog
      v-model="editDialog"
      :save-button-text="$t('save')"
      :title="$t('editEnvironment')"
      :max-width="700"
      @save="loadItems"
      :help-button="true"
      :no-escape="editNoEscape"
      test-id="varGroupDialog"
    >
      <template v-slot:form="{ onSave, onError, needSave, needReset, needHelp }">
        <EnvironmentForm
          :project-id="projectId"
          :item-id="itemId"
          @save="onSave"
          @error="onError"
          :need-save="needSave"
          :need-reset="needReset"
          :need-help="needHelp"
          :support-storages="premiumFeatures.secret_storages"
          @maximize="editNoEscape = $event.maximized"
        />
      </template>
    </EditDialog>

    <ObjectRefsDialog
      object-title="environment"
      :object-refs="itemRefs"
      :project-id="projectId"
      v-model="itemRefsDialog"
    />

    <YesNoDialog
      :title="$t('deleteEnvironment')"
      :text="$t('askDeleteEnv')"
      v-model="deleteItemDialog"
      @yes="deleteItem(itemId)"
    />

    <YesNoDialog
      :title="$t('deleteN', { count: selectedItems.length })"
      :text="$t('bulkDeleteConfirm', { count: selectedItems.length })"
      v-model="bulkDeleteDialog"
      @yes="bulkDelete()"
    />

    <v-toolbar flat>
      <v-app-bar-nav-icon @click="showDrawer()"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $t('environment') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <ListToolbar
        :value="searchText"
        :selection-count="selectedItems.length"
        @search="onSearchInput($event)"
        @bulk-delete="askBulkDelete()"
        class="mr-3"
      />
      <v-btn
        color="primary"
        @click="editItem('new')"
        v-if="can(USER_PERMISSIONS.manageProjectResources)"
        >{{ $t('newEnvironment') }}
      </v-btn>
    </v-toolbar>

    <v-divider />

    <v-data-table
      v-model="selectedItems"
      show-select
      item-key="id"
      :headers="headers"
      :items="items"
      :search="searchText"
      :custom-filter="filterByName"
      class="mt-4 CenterToScreen"
      :items-per-page="25"
      :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100] }"
      :no-data-text="searchText ? $t('noMatches') : $t('noItems')"
    >
      <template v-slot:item.name="{ item }">
        <a @click="editItem(item.id)">{{ item.name }}</a>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn-toggle dense :value-comparator="() => false">
          <v-btn
            v-if="item.sync_enabled"
            @click="syncItem(item.id)"
            :disabled="!(item.sync_paths && item.sync_paths.length > 0)"
          >
            <ZpIcon name="refresh-cw" :size="18" />
          </v-btn>
          <v-btn @click="askDeleteItem(item.id)">
            <ZpIcon name="trash-2" :size="18" />
          </v-btn>
          <v-btn @click="editItem(item.id)">
            <ZpIcon name="pencil" :size="18" />
          </v-btn>
        </v-btn-toggle>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import ItemListPageBase from '@/components/ItemListPageBase';
import EnvironmentForm from '@/components/EnvironmentForm.vue';
import PageMixin from '@/components/PageMixin';
import axios from 'axios';
import EventBus from '@/event-bus';
import { getErrorMessage } from '@/lib/error';
import ListToolbar from '@/components/ListToolbar.vue';

export default {
  components: { EnvironmentForm, ListToolbar },
  mixins: [ItemListPageBase, PageMixin],
  data() {
    return {
      editNoEscape: false,
    };
  },
  methods: {
    async syncItem(itemId) {
      try {
        await axios({
          method: 'post',
          url: `/api/project/${this.projectId}/environment/${itemId}/sync`,
          responseType: 'json',
        });
        EventBus.$emit('i-snackbar', {
          color: 'success',
          text: this.$t('variableGroupSyncedSuccessfully'),
        });
        await this.loadItems();
      } catch (err) {
        EventBus.$emit('i-snackbar', {
          color: 'error',
          text: getErrorMessage(err),
        });
      }
    },
    getHeaders() {
      return [
        {
          text: this.$i18n.t('name'),
          value: 'name',
          width: '100%',
        },
        {
          value: 'actions',
          sortable: false,
          align: 'end',
        },
      ];
    },
    getItemsUrl() {
      return `/api/project/${this.projectId}/environment`;
    },
    getSingleItemUrl() {
      return `/api/project/${this.projectId}/environment/${this.itemId}`;
    },
    getEventName() {
      return 'i-environment';
    },
  },
};
</script>
